<template>
  <div class="module-afiliasi">
    <SOSlotBase :container-name="'terms-page-content'">
      <template v-slot:title-bar>
        <div>
          <SOTitleBar :page-title="pageTitle" :type="'back'" @back="back" />
        </div>
      </template>

      <template v-slot:content>
        <div class="terms-content">
          <div class="terms-conditions m-t-16" v-for="(tc, idx) in termsCondition" :key="`label${idx}`">
            <label class="f-16 f-semi f-c-black m-d-12">{{ tc.label }}</label>
            <div v-for="(data, keys) in tc.data" :key="`items${keys}`" class="terms-conditions-item m-d-8">
              <div class="num-item">
                <span class="f-14 f-regular f-c-midgrey">{{ keys + 1 }}.</span>
              </div>
              <div class="text-item">
                <span class="f-14 f-regular f-c-midgrey">{{ data.name }}</span>
              </div>
            </div>
            <div class="separator-line m-d-20 m-t-20" v-if="idx < termsCondition.length - 1"></div>
            <div class="separator m-d-20 m-t-20" v-if="idx === termsCondition.length - 1 && isShownApproval"></div>
          </div>
          <div class="term-approval" v-if="isShownApproval">
            <label>
              <input type="checkbox" v-model="termsAproval" />
              <span class="m-l-4 f-c-black f-regular f-14">
                Saya sudah membaca dan setuju dengan ketentuan yang tertulis
              </span>
            </label>
          </div>
          <div class="terms-btn" v-if="isShownApproval">
            <SOButton
              :primary="true"
              :full="true"
              :text="'Daftar Menjadi Afiliator '"
              :id="`terms-btn-request`"
              :disable="isFetching || !termsAproval"
              :loading="isFetching"
              @action="onRegister"
            />
          </div>
        </div>
      </template>
    </SOSlotBase>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

import SOSlotBase from "@/so-components/global/slot/SOSlotBase";
import SOTitleBar from "@/so-components/global/ui/SOTitleBar";
import SOButton from "@/so-components/global/ui/SOButton";

import { moduleName } from "../store/state";

import terms from "../static/termsAndConditions";

export default {
  name: "TermsPage",
  components: {
    SOSlotBase,
    SOTitleBar,
    SOButton,
  },
  data() {
    return {
      termsAproval: false,
      showApproval: true,
      backLink: "afiliasi.welcome_page",
      titlePage: "Perjanjian Afiliasi",
    };
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (to.name === "afiliasi.terms_conditions") {
        vm.setBackLink(from.name);
        vm.setShownApproval(false);
        vm.setTitlePage("Syarat dan Ketentuan");
      }

      if (to.name === "afiliasi.terms") {
        vm.setShownApproval(true);
        vm.setTitlePage("Perjanjian Afiliasi");
      }
    });
  },
  watch: {
    getResponse: function(newRes, oldRes) {
      if (newRes.success) {
        this.$router.push({ name: "afiliasi.sucsess" });
      }
    },
  },
  computed: {
    ...mapGetters(moduleName, {
      isFetching: "isFecthing",
      getResponse: "getResponse",
    }),
    termsCondition() {
      let list = [];

      Object.keys(terms).forEach(function(key) {
        list.push(terms[key]);
      });

      return list;
    },
    isShownApproval() {
      return this.showApproval;
    },
    pageTitle() {
      return this.titlePage;
    },
  },
  methods: {
    ...mapActions({
      registerAfiliator: `${moduleName}/registerAfiliator`,
    }),
    back() {
      this.$router.push({ name: this.backLink });
    },
    onRegister() {
      this.registerAfiliator();
    },
    setShownApproval(approval) {
      this.showApproval = approval;
    },
    setBackLink(link) {
      this.backLink = link;
    },
    setTitlePage(title) {
      this.titlePage = title;
    },
  },
};
</script>
<style scoped>
.terms-content {
  padding-left: 20px;
  padding-right: 20px;
}

.terms-conditions-item {
  display: grid;
  grid-template-columns: repeat(15, minmax(0, 1fr));
}

.terms-conditions-item div.num-item {
  justify-self: end;
  padding-right: 8px;
}

.terms-conditions-item div.text-item {
  grid-column: span 14 / span 14;
  padding-left: 4px;
}

.term-approval {
  display: flex;
  flex-direction: column;
}

.term-approval label {
  display: inline-flex;
  align-items: normal;
}
.term-approval label input {
  height: 1.25rem;
  width: 1.25rem;
}
</style>
